export const getPsFromKw = (value: number) => Math.round(value * 1.35962);
